import React, { useState, useEffect } from 'react';
import {
  Card, CardBody, Table, Col, Row
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 35,
    justifyContent: 'start',
    display: 'inline'
  },
  group: {
    display: 'inline !important'
  }
}));

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#84ffe7',
      main: '#49e0b5',
      dark: '#00ad85',
      contrastText: '#fff',
      height: '10px'
    },
  },
});

const BasicTable = ({ t, data, answers, setAnswers, medicamet, setMedicamet, disabled,
  radio1, setRadio1,
  radio2, setRadio2,
  radio3, setRadio3,
  radio4, setRadio4,
  radio5, setRadio5,
  radio6, setRadio6,
  radio7, setRadio7,
  radio8, setRadio8,
  radio9, setRadio9,
  radio10, setRadio10,
  radio11, setRadio11,
  radio12, setRadio12,
  observacion, setObservacion, }) => {

  const [questions, setQuestion] = useState(
    [
      { question: 'PACIENTE CORRECTO' },
      { question: 'PROCEDIMIENTO CORRECTO SOLICITADO' },
      { question: 'VERIFICAR CONDICIONES PARA EL PROCEDIMIENTO' },
      { question: 'a. Cumple con los requerimientos del examen' },
      { question: 'b. Suspension Medicamento' },
      { question: 'c. Otros' },
      { question: 'REQUIERE ALGUN MEDICAMENTO PARA EL EXAMEN' },
      { question: 'MEDICAMENTO CORRECTO' },
      { question: 'VIA DE ADMINISTRACIÓN CORRECTA' },
      { question: 'DOSIS' },
      { question: 'MOMENTO U HORARIO CORRECTO' },
      { question: 'INFORMAR AL PACIENTE LA NECESIDAD DEL USO DEL MEDICAMENTO' },
      { question: 'SE INFORMARON POSIBLES EFECTOS SECUNDARIOS' },
    ]);


  const BasicTableData = () => {
    const header = [
      { id: 1, title: '#' },
      { id: 2, title: 'Fecha', accesor: 'fecha' },
      { id: 3, title: 'Hora', accesor: 'hora' },
      { id: 4, title: 'Codigo', accesor: 'codigo' },
      { id: 5, title: 'Nombre', accesor: 'nombre' },
      { id: 6, title: 'Requiere Medicamentos', accesor: 'medicamentos' },
    ];

    const headerResponsive = [
      { id: 1, title: '#' },
      { id: 2, title: 'Fecha', accesor: 'fecha' },
      { id: 3, title: 'Hora', accesor: 'hora' },
      { id: 4, title: 'Codigo', accesor: 'codigo' },
      { id: 5, title: 'Nombre', accesor: 'nombre' },
      { id: 6, title: 'Requiere Medicamentos', accesor: 'medicamentos' },
    ];

    const rows = [{
      id: 1,
      fecha: moment(new Date()).format('YYYY-MM-DD'),
      hora: moment(new Date()).format('HH:MM A'),
      codigo: '3564',
      nombre: 'CARDIOLOGIA',
      medicamentos: 'Si'
    }];

    const basicTableData = { tableHeaderData: header, tableHeaderResponsiveData: headerResponsive, tableRowsData: rows };
    return basicTableData;
  };



  const handlerMedicamet = (e, index) => {
    let mediTemp = [...medicamet];

    if (index !== 3)
      mediTemp[index] = e.target.value;
    else
      mediTemp[index] = moment(e).format('YYYY-MM-DD');

    setMedicamet(mediTemp);
  }

  const handlerQuestions = (e, index) => {
    var answersNew = [...answers];
    answersNew[index] = e.target.value;

    setAnswers(answersNew);
  }


  useEffect(() => {
    //console.log(answers);
    //console.log(medicamet);
    console.log("stateObservation", observacion)
  }, [answers])

  const classes = useStyles();

  return (<div className="form form--preview">
    <Card style={{ paddingBottom: 0 }}>
      <CardBody style={{ padding: 0 }}>
        <Row>
          <Col>
            <ThemeProvider theme={theme}>
              <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio1.question}</FormLabel>
                <RadioGroup
                  aria-label="rigth_patient"
                  name="Paciente Correcto"
                  value={radio1.answer}
                  onChange={e => { setRadio1({ ...radio1, answer: e.target.value }) }}
                  className={classes.group}
                >
                  <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                  <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </Col>
        </Row>
        <Row>
          <Col>
            <ThemeProvider theme={theme}>
              <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio2.question}</FormLabel>
                <RadioGroup
                  aria-label="rigth_patient"
                  name="radio2"
                  value={radio2.answer}
                  style={{ display: 'inline' }}
                  onChange={e => { setRadio2({ ...radio2, answer: e.target.value }) }}
                  className={classes.group}
                >
                  <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                  <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </Col>
        </Row>
        <Row>
          <Col>
            <ThemeProvider theme={theme}>
              <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>VERIFICAR CONDICIONES PARA EL PROCEDIMIENTO</FormLabel>
              <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio3.question}</FormLabel>
                <RadioGroup
                  aria-label="rigth_patient"
                  name="radio2"
                  value={radio3.answer}
                  style={{ display: 'inline' }}
                  onChange={e => { setRadio3({ ...radio3, answer: e.target.value }) }}
                  className={classes.group}
                >
                  <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                  <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                  <FormControlLabel value="NO APLICA" control={<Radio color="primary" disabled={disabled} />} label="NO APLICA" />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </Col>
        </Row>
        <Row>
          <Col>
            <ThemeProvider theme={theme}>
              <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio4.question}</FormLabel>
                <RadioGroup
                  aria-label="rigth_patient"
                  name="radio2"
                  value={radio4.answer}
                  style={{ display: 'inline' }}
                  onChange={e => { setRadio4({ ...radio4, answer: e.target.value }) }}
                  className={classes.group}
                >
                  <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                  <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                  <FormControlLabel value="NO APLICA" control={<Radio color="primary" disabled={disabled} />} label="NO APLICA" />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </Col>
        </Row>
        <Row>
          <Col>
            <ThemeProvider theme={theme}>
              <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio5.question}</FormLabel>
                <RadioGroup
                  aria-label="rigth_patient"
                  name="radio2"
                  value={radio5.answer}
                  style={{ display: 'inline' }}
                  onChange={e => { setRadio5({ ...radio5, answer: e.target.value }) }}
                  className={classes.group}
                >
                  <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                  <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                  <FormControlLabel value="NO APLICA" control={<Radio color="primary" disabled={disabled} />} label="NO APLICA" />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </Col>
        </Row>
        <Row>
          <Col>
            <ThemeProvider theme={theme}>
              <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio6.question}</FormLabel>
                <RadioGroup
                  aria-label="rigth_patient"
                  name="radio2"
                  value={radio6.answer}
                  style={{ display: 'inline' }}
                  onChange={e => { setRadio6({ ...radio6, answer: e.target.value }) }}
                  className={classes.group}
                >
                  <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                  <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </Col>
        </Row>
        {radio6.answer === "SI" ?
          <>
            <Row >
              <Col>
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio7.question}</FormLabel>
                    <RadioGroup
                      aria-label="rigth_patient"
                      name="radio2"
                      value={radio7.answer}
                      style={{ display: 'inline' }}
                      onChange={e => { setRadio7({ ...radio7, answer: e.target.value }) }}
                      className={classes.group}
                    >
                      <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                      <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </Col>
            </Row>
            <Row>
              <Col>
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio8.question}</FormLabel>
                    <RadioGroup
                      aria-label="rigth_patient"
                      name="radio2"
                      value={radio8.answer}
                      style={{ display: 'inline' }}
                      onChange={e => { setRadio8({ ...radio8, answer: e.target.value }) }}
                      className={classes.group}
                    >
                      <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                      <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </Col>
            </Row>
            <Row>
              <Col>
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio9.question}</FormLabel>
                    <RadioGroup
                      aria-label="rigth_patient"
                      name="radio2"
                      value={radio9.answer}
                      style={{ display: 'inline' }}
                      onChange={e => { setRadio9({ ...radio9, answer: e.target.value }) }}
                      className={classes.group}
                    >
                      <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                      <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </Col>
            </Row>
            <Row>
              <Col>
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio10.question}</FormLabel>
                    <RadioGroup
                      aria-label="rigth_patient"
                      name="radio2"
                      value={radio10.answer}
                      style={{ display: 'inline' }}
                      onChange={e => { setRadio10({ ...radio10, answer: e.target.value }) }}
                      className={classes.group}
                    >
                      <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                      <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </Col>
            </Row>
            <Row>
              <Col>
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio11.question}</FormLabel>
                    <RadioGroup
                      aria-label="rigth_patient"
                      name="radio2"
                      value={radio11.answer}
                      style={{ display: 'inline' }}
                      onChange={e => { setRadio11({ ...radio11, answer: e.target.value }) }}
                      className={classes.group}
                    >
                      <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                      <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </Col>
            </Row>
            <Row>
              <Col>
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row' }}>
                    <FormLabel component="legend" style={{ width: 500, marginTop: 10 }}>{radio12.question}</FormLabel>
                    <RadioGroup
                      aria-label="rigth_patient"
                      name="radio2"
                      value={radio12.answer}
                      style={{ display: 'inline' }}
                      onChange={e => { setRadio12({ ...radio12, answer: e.target.value }) }}
                      className={classes.group}
                    >
                      <FormControlLabel value="SI" control={<Radio color="primary" disabled={disabled} />} label="SI" />
                      <FormControlLabel value="NO" control={<Radio color="primary" disabled={disabled} />} label="NO" />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
              </Col>
            </Row>
          </>
          : null}
        <div className="form__form-group" style={{ marginTop: 10 }}>
          <span className="form__form-group-label"><b>Observaciones</b></span>
          <div className="form__form-group-field">
            <Field
              name="textarea-TEN"
              component="textarea"
              value={observacion}
              disabled={disabled}
              type="text"
              onChange={(e) => {
                setObservacion(e.target.value);
              }}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  </div >)
};

BasicTable.propTypes = {
  t: PropTypes.func.isRequired,
};

//export default withTranslation('common')();
export default reduxForm({
  form: 'medical_ten_corrects_form', // a unique identifier for this form
})(withTranslation('common')(BasicTable));